<template>
    <v-container fill-height fill-width class="v-contain">
        <v-layout>
            <v-row>
                <v-col cols="3" class="v-col-right">
                    <v-row no-gutters class="pb-4 pt-2">
                        <v-col cols="10">
                            Affiner la recherche
                        </v-col>
                        <v-col cols="2">
                            <v-icon>mdi-filter</v-icon>
                        </v-col>
                    </v-row>
                    <v-divider class="mb-2"></v-divider>
                    <v-row no-gutters v-if="dashboardConfig && dashboardConfig.userDto && groupsSansEcolesAuthorise.includes(dashboardConfig.userDto.groupeId)">
                        <v-col cols="12">
                            <v-autocomplete class="pt-0" :menu-props="{maxHeight:'40%'}"
                                            label="Ecole"
                                            v-model="filtres.Ecole"
                                            clearable
                                            :items="dashboardConfig.listEcole"
                                            item-text="lang00"
                                            item-value="Id"
                                            return-object></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-autocomplete class="pt-0" :menu-props="{maxHeight:'40%'}"
                                            label="Campus"
                                            clearable
                                            v-model="filtres.Campus"
                                            :items="dashboardConfig.listCampus"
                                            item-text="lang00"
                                            item-value="Id"
                                            return-object></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-autocomplete class="pt-0" :menu-props="{maxHeight:'40%'}"
                                            label="Type de rentée"
                                            clearable
                                            v-model="filtres.TypeRentre"
                                            :items="dashboardConfig.listTypeRentre"
                                            item-text="lang00"
                                            item-value="Id"
                                            return-object></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-autocomplete class="pt-0" :menu-props="{maxHeight:'40%'}"
                                            label="Type Programme"
                                            clearable
                                            v-model="filtres.TypeProgramme"
                                            :items="dashboardConfig.listTypeProgramme"
                                            item-text="lang00"
                                            item-value="Id"
                                            return-object></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-autocomplete class="pt-0" :menu-props="{maxHeight:'40%'}"
                                            label="Cycle"
                                            clearable
                                            v-model="filtres.Cycle"
                                            :items="dashboardConfig.listCycle"
                                            item-text="lang00"
                                            item-value="Id"
                                            return-object></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-autocomplete class="pt-0" :menu-props="{maxHeight:'40%'}"
                                            clearable
                                            label="Langue d'étude"
                                            v-model="filtres.LangueEtude"
                                            :items="dashboardConfig.listLangueEtude"
                                            item-text="lang00"
                                            item-value="Id"
                                            return-object></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-text-field clearable
                                          type="number"
                                          v-model="filtres.NombreRelance"
                                          label="Nombre de relance"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-checkbox label="Jamais relancé" v-model="filtres.JamaisRelance"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <vc-date-picker v-model="filtres.DateMin" update-on-input @input="dateSelectedDebut">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <v-text-field label="Créée à partir du"
                                                  @blur="inputDateSelectedDebut"
                                                  v-model="dateFiltreTextDebut"
                                                  v-on="inputEvents"
                                                  placeholder="DD/MM/YYYY"
                                                  clearable
                                                  prepend-inner-icon="calendar_today" />
                                </template>
                            </vc-date-picker>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <vc-date-picker v-model="filtres.DateMax" update-on-input @input="dateSelectedEnd">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <v-text-field label="Jusqu'au"
                                                  :value="inputValue"
                                                  @blur="inputDateSelectedEnd"
                                                  v-model="dateFiltreTextEnd"
                                                  v-on="inputEvents"
                                                  placeholder="DD/MM/YYYY"
                                                  clearable
                                                  prepend-inner-icon="calendar_today" />
                                </template>
                            </vc-date-picker>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-btn @click="lancerRecherche(true)">
                                Rechercher
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <!--mettre en place le v-if avec cols = 9 ou cols = 12-->
                <v-col cols="9" class="background-col-right">
                    <v-row class="pt-4 pb-4 pr-4 pl-6">
                        <v-col cols="3">
                            <v-card class="text-xs-center widget-candidature-selected" :class="{selected : isStatutEnCours}" @click="pushStatut(statut01)">
                                <v-card-title class="pb-0">
                                    <v-spacer />
                                    <div class="text-center">
                                        <h3 class="headline text--accent-2">{{datasDashboard.totalCandidatureEnCours}}</h3>
                                    </div>
                                    <v-spacer />
                                </v-card-title>
                                <v-card-actions class="pb-0" :class="[PaddingIsStatutEnCours]">
                                    <v-spacer /><p>Candidatures en cours</p><v-spacer />
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="3">
                            <v-card class="text-xs-center widget-candidature" :class="{selected : isStatutAValider}" @click="pushStatut(statut02)">
                                <v-card-title class="pb-0">
                                    <v-spacer />
                                    <div class="text-center">
                                        <h3 class="headline text--accent-2">{{datasDashboard.totalCandidatureAValider}}</h3>
                                    </div>
                                    <v-spacer />
                                </v-card-title>
                                <v-card-actions class="pb-0" :class="[PaddingIsStatutAValider]">
                                    <v-spacer /><p>Candidatures à valider</p><v-spacer />
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="3">
                            <v-card class="text-xs-center widget-candidature" :class="{selected : isStatutValider}" @click="pushStatut(statut03)">

                                <v-card-title class="pb-0">
                                    <v-spacer />
                                    <div class="text-center">
                                        <h3 class="headline text--accent-2">{{datasDashboard.totalCandidatureValide}}</h3>
                                    </div>
                                    <v-spacer />
                                </v-card-title>
                                <v-card-actions class="pb-0" :class="[PaddingIsStatutValider]">
                                    <v-spacer /><p>Candidatures validées</p><v-spacer />
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="3">
                            <v-card class="text-xs-center widget-candidature" :class="{selected : isStatutVersAdmin}" @click="pushStatut(statut04)">
                                <v-card-title class="pb-0">
                                    <v-spacer />
                                    <div class="text-center">
                                        <h3 class="headline text--accent-2">{{datasDashboard.totalCandidatureEnAttenteDePaiement}}</h3>
                                    </div>
                                    <v-spacer />
                                </v-card-title>
                                <v-card-actions class="pb-0" :class="[PaddingIsStatutVersAdmin]">
                                    <v-spacer /><p>Candidatures vers admis</p><v-spacer />
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row class="pt-4 pb-4 pr-4 pl-6">
                        <v-card width="95vw">
                            <v-data-table :headers="headers"
                                          :server-items-length="datasDashboard.totalCandidature"
                                          :options.sync="options"
                                          :items="datasDashboard.listCandidatureDtos"
                                          :items-per-page="5"
                                          :loading="$storeCandidature.loadingConfig"
                                          :footer-props="footerProps"
                                          @click:row="redirectionCandidature"
                                          class="elevation-1">
                                <template v-slot:item.createdAt="{ item }">
                                    {{ $moment(String(item.createdAt)).format('DD/MM/YYYY') }}
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-row>
                </v-col>
            </v-row>
        </v-layout>
    </v-container>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                headers: [
                    {
                        text: 'Candidature',
                        align: 'start',
                        sortable: true,
                        value: 'label',
                    },
                    { text: 'Campus', value: 'campus.lang00', sortable: true },
                    { text: 'Type du programe', value: 'typePrograme.lang00', sortable: true },
                    { text: 'Niveau d\'adminssion', value: 'niveauAdminssion.lang00', sortable: true },
                    { text: 'Date', value: 'createdAt', sortable: true },
                    { text: 'Nombre de relances', value: 'nombreRelance', sortable: true },
                ],
                statut01: 1002989,// 01. Candidat en cours.
                statut02: 1006580,// 02. Candidat à valider.
                statut03: 1002991,// 03. Candidat validé.
                statut04: 1002994,// 04. Admis - Inscription en attente de paiement.
                groupsSansEcolesAuthorise: [55, 52],
                $storeCandidature: this.$storeCandidature,
                datasDashboard: {
                    totalCandidature: 0,
                    totalCandidatureAValider: 0,
                    totalCandidatureValide: 0,
                    totalCandidatureEnAttenteDePaiement: 0,
                    totalCandidatureEnCours: 0,
                    listCandidatureDtos: [],
                },
                footerProps: {
                    itemsPerPageOptions: [15],
                    showFirstLastPage: true,
                },
                options: {
                    page: 1
                },
                dateFiltreTextDebut: null,
                dateFiltreTextEnd: null,
                token: '',
                filtres: {
                    Cycle: null,
                    TypeProgramme: null,
                    LangueEtude: null,
                    Ecole: null,
                    Campus: null,
                    TypeRentre: null,
                    DateMin: null,
                    DateMax: null,
                    NombreRelance: null,
                    JamaisRelance: false,
                    statut: null,
                },
                dashboardConfig: {
                    UserDto: {},
                    listCycle: [],
                    listTypeProgramme: [],
                    listLangueEtude: [],
                    listEcole: [],
                    listCampus: [],
                    listTypeRentre: [],
                    listProgrammeDto: [],
                }
            }
        },
        watch: {
            options: {
                handler() {
                    this.lancerRecherche(false);
                }
            },
        },
        computed: {
            isStatutEnCours() {
                return (this.filtres.statut === this.statut01);
            },
            isStatutAValider() {
                return (this.filtres.statut === this.statut02);
            },
            isStatutValider() {
                return (this.filtres.statut === this.statut03);
            },
            isStatutVersAdmin() {
                return (this.filtres.statut === this.statut04);
            },
            PaddingIsStatutEnCours() {
                return this.isStatutEnCours ? "pt-2" : "pt-4";
            },
            PaddingIsStatutAValider() {
                return this.isStatutAValider ? "pt-2" : "pt-4";
            },
            PaddingIsStatutValider() {
                return this.isStatutValider ? "pt-2" : "pt-4";
            },
            PaddingIsStatutVersAdmin() {
                return this.isStatutVersAdmin ? "pt-2 pr-0" : "pt-4";
            },
        },
        methods: {
            async pushStatut(nouveauStatut) {

                // Si on affecte 2 fois le même statut alors on reset.
                if (nouveauStatut === this.filtres.statut) {
                    this.filtres.statut = null;
                }
                // Sinon on affecte la nouvelle valeur.
                else {
                    this.filtres.statut = nouveauStatut;
                }

                // Lancer la recherche.
                await this.lancerRecherche(true);
            },
            dateSelectedDebut() {
                if (this.filtres.DateMin != null) {
                    this.dateFiltreTextDebut = this.$moment(String(this.filtres.DateMin)).format('DD/MM/YYYY')
                }
                else {
                    this.dateFiltreTextDebut = null;
                }
            },
            dateSelectedEnd() {
                if (this.filtres.DateMax != null) {
                    this.dateFiltreTextEnd = this.$moment(String(this.filtres.DateMax)).format('DD/MM/YYYY')
                }
                else {
                    this.dateFiltreTextEnd = null;
                }
            },
            inputDateSelectedDebut() {

                // Permet de virifier le format de la date.
                let date = this.$moment(this.dateFiltreTextDebut, 'DD/MM/YYYY', true);

                // Si la date est valide alors on affecte.
                if (date.isValid()) {
                    this.filtres.DateMin = Date.parse(date);
                }

                // Sinon on vide.
                else {
                    this.filtres.DateMin = null;
                    this.dateFiltreTextDebut = null;                    
                }
            },
            inputDateSelectedEnd() {

                // Permet de virifier le format de la date.
                let date = this.$moment(this.dateFiltreTextEnd, 'DD/MM/YYYY', true);

                // Si la date est valide alors on affecte.
                if (date.isValid()) {
                    this.filtres.DateMax = Date.parse(date);
                }

                // Sinon on vide.
                else {
                    this.filtres.DateMax = null;
                    this.dateFiltreTextEnd = null;
                }
            },
            async lancerRecherche(resetPage) {

                // Afficher le chargement.
                this.$storeCandidature.loadingConfig = true

                // Sauvegarder les paramètres de recherche.
                this.pushFilterLocalStorage()

                const params = new URLSearchParams();
                params.append('page', this.options.page)
                params.append('rowPerPage', this.options.itemsPerPage)
                params.append('sortBy', this.options.sortBy)
                params.append('sortDesc', this.options.sortDesc)

                await apidashboard.post(`search?${params}`, this.filtres, {
                    headers: {
                        Authorization: `s-auth ${this.token}`,
                    }
                }).then((response) => {
                    if (response.data) {

                        // Récupération des datas.
                        this.datasDashboard = { ...response.data }

                        if (resetPage) {
                            // Retour à la page 1.
                            this.options.page = 1;
                        }
                    }
                }).finally(() => {

                    this.$storeCandidature.loadingConfig = false
                });
            },
            pushFilterLocalStorage() {

                // Enregistre dans le localstorage les infos.
                localStorage.setItem('dashbordFilters', JSON.stringify(this.filtres))
            },
            recupererToken() {

                let eudonetparams = JSON.parse(sessionStorage.getItem('eudonetparams'))

                if (eudonetparams != undefined && eudonetparams.t) {
                    // Récupération du token depuis le local storage
                    this.token = eudonetparams.t
                } else {

                    alert('Connexion refusée')
                    // destroy the vue listeners, etc
                    this.$destroy();

                    // Pour le debug.
                    //this.token = "";
                }
            },
            redirectionCandidature(value) {

                // Obliger de passer par un let car value et ses attributs ne peuvent pas être transmit à un élément parent.
                let id = value.id;

                // Methode du noyau pour rediriger vers la bonne fiche.
                top.loadFile(1400, id);
            },
            async loadConfiguration() {

                this.loadLocalStorage();
                await this.loadFileData();
            },
            async loadFileData() {
                await apidashboard.get('configdashboard', {
                    headers: {
                        Authorization: `s-auth ${this.token}`,
                    }
                }).then((response) => {
                    if (response.data) {

                        this.dashboardConfig = { ...response.data };
                    }
                }).finally(() => {
                    this.$storeCandidature.loadingConfig = false
                });
            },
            loadLocalStorage() {

                // Récupération des données depuis le local storage.
                let filtresLocalStorage = JSON.parse(localStorage.getItem('dashbordFilters'));

                // Si des filtres existe, on les affecte.
                if (filtresLocalStorage) {

                    this.filtres = filtresLocalStorage;
                }
            }
        },
        beforeDestroy() {
            this.$root.$el.parentNode.removeChild(this.$root.$el)
        },
        mounted() {
            this.recupererToken();
            this.loadConfiguration();
        },
    }

    export const apidashboard = axios.create({
        baseURL: process.env.VUE_APP_BASE_API_URL_DASHBOARD,
        withCredentials: false,
        headers: {
            Accept: 'application/json',
        }
    });
</script>

<style scoped>
    .v-col-right {
        border-right: 1px solid #e4e4e4;
    }

    .v-contain {
        margin-left: 0px;
        margin-right: 0px !important;
        width: 100%;
    }

    .background-col-right {
        background-color: #f2f2f2;
    }

    .widget-candidature {
        cursor: pointer;
    }

    .selected {
        border: 5px solid green;
    }
</style>